<template>
  <div>
    <div v-if="transact">
      <span v-if="otherTableData.length ===0" style="margin-right:20px">暂无数据</span><br>

      <div v-if="otherTableData.length !=0" style="margin-right:20px">
        已申请分批发货信息
      </div>
      <Collapse v-for="(items, indexs) in otherTableData" :key="indexs">
        <div slot="header">
          <div class="headerItem">
            <span>
              配送至:{{ items.receiptAddressInfo.province }}{{ items.receiptAddressInfo.city }}{{ items.receiptAddressInfo.county }}{{ items.receiptAddressInfo.receiptAddress }}
            </span>
            <span style="margin-left:20px">
              实际结算金额:{{ items.settlementAmountTotal }}元

            </span>
            <span style="margin-left:10px">
              发货数量总计：{{ items.productNumTotal }}
            </span>
          </div>
          <!-- <div />
          <div /> -->
        </div>
        <div v-for="(item,index) in items.partialInvoiceInfoList" :key="index">
          <!-- <span style="margin-right:20px">分批发货单号:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.deliveryNum }}</span> -->
          <span style="margin-right: 20px">分批申请单号:&nbsp;&nbsp;&nbsp;&nbsp;
            <span style="color:#53a8ff ;display:inline-block;cursor:pointer;" @click="fpfh(item)">
              {{ item.deliveryNum }}
            </span>
          </span>
          <span style="margin-right:20px">申请日期:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.createTime }}</span>
          <span style="margin-right:20px">发货单号:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.invoiceNum }}</span>
          <!-- <span style="margin-right:20px">物流单号:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.logisticsNum }}</span> -->
          <span style="margin-right: 20px;">物流单号:&nbsp;&nbsp;&nbsp;&nbsp;
            <span style="color:#53a8ff ;display:inline-block;cursor:pointer;" @click="logisticClick(item)">
              {{ item.logisticsNum }}
            </span>
          </span>
          <span style="margin-right:20px">组织:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.organization }}</span>
          <span style="margin-right:20px">仓库:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.warehouse }}</span>
          <span style="margin-right:20px">货运属性:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.freightProperty }}</span>
          <!-- <el-button type="primary" @click="removeApply(item)">撤销申请</el-button> -->
          <el-table v-loading="loading"
                    :data="item.partialInvoiceProductList"
                    style="width: 100%;margin-top:10px;margin-bottom:10px"
                    border
                    show-summary
                    :summary-method="getSummaries"
          >
            <el-table-column prop="itemIndex" label="序号" align="left" fixed="left" width="50" />
            <el-table-column prop="orderNumber" label="订单号" align="left" fixed="left" />
            <el-table-column prop="materialNumber" label="物品代码" align="left" />
            <el-table-column prop="productName" label="物品名称" align="left" />
            <el-table-column prop="productNum" label="数量" align="left" />
            <el-table-column prop="productPriceSigle" label="实际结算单价" align="right" header-align="left" />
            <el-table-column prop="settlementAmount" label="实际结算金额" align="right" header-align="left" />
            <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" align="left" width="200" />
            <el-table-column prop="agreedDate" label="约定交付日期" align="left" width="200" />
            <el-table-column prop="pname" label="查看序列号" align="left">
              <template v-slot="{ row }">
                <lookserial-number
                  :str-contract-code="$route.params.contractNum"
                  :product-name="row.productName"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </Collapse>
    </div>
    <div v-if="!transact" v-loading="loading" class="approve-style">
      <p>
        分批发货说明：
      </p>

      <p> 1、工作日的10:30-23:59允许申请分批发货，新单当天不允许申请分批发货</p>

      <p> 2、约定交付日期小于等于当天的才允许申请分批发货</p>

      <p>3、现销的申请分批发货后需先付款流程才能到订单员，赊销的申请分批发货后无需付款流程即可到订单员</p>
      <p style="margin-bottom: 20px">
        4、货运方式为供应商直发的产品预计在提交申请三天后发货
      </p>
      <p v-if="applyGoodsBaseInfo.freightPayType === 1 && applyGoodsBaseInfo.partialInvoiceVO.length>1" style="color:red">
        此单运费差价使用返利支付，只可以批量操作
      </p>
      <div v-for="(items,index) in applyGoodsBaseInfo.partialInvoiceVO" :key="index">
        <p>
          <!-- <span style="margin-right:20px">分批申请单号：{{ items.partialInvoiceNum }}</span> -->
          <span style="margin-right: 20px">分批申请单号:&nbsp;&nbsp;&nbsp;&nbsp;
            <span style="color:#53a8ff ;display:inline-block;cursor:pointer;" @click="fpfh(items)">
              {{ items.partialInvoiceNum }}
            </span>
          </span>
          <span style="margin-right:20px">组织：{{ items.organization }}</span>
          <span style="margin-right:20px">仓库：{{ items.warehouse }}</span>
          <span style="margin-right:20px">货运属性：{{ items.freightProperty }}</span>
          <span v-if="applyGoodsBaseInfo.freightPayType !== 1 || applyGoodsBaseInfo.partialInvoiceVO.length===1">
            <el-button type="primary" :loading="agreeLoading" @click="agree(items)">同意</el-button>
            <el-button type="warning" style="margin-left:20px" @click="reject(items)">驳回</el-button>
          </span>
        </p>
        <el-table
          :data="items.invoiceProductList"
          border
          style="width: 100%;margin-top:10px;margin-bottom:10px"
          show-summary
          :summary-method="getSummaries"
        >
          <el-table-column prop="itemIndex" width="80" label="序号" align="left" fixed="left" />
          <el-table-column prop="contractNum" label="合同号" align="left" fixed="left" width="170" />
          <el-table-column prop="materialNumber" label="物品代码" align="left" />
          <el-table-column prop="productName" label="物品名称" align="left" />
          <el-table-column prop="productNum" label="数量" align="left" width="70" />
          <el-table-column prop="productPriceSigle" label="实际结算单价" align="right" header-align="left" />
          <el-table-column prop="settlementAmount" label="实际结算金额" align="right" header-align="left" />
          <el-table-column prop="deliveryAddress" label="收货地址" align="left"/>
          <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" align="left" width="150" />
          <el-table-column prop="agreedDate" label="约定交付日期" align="left" width="150" />
          <!-- <el-table-column prop="freightProperty" label="货运属性" align="left" width="150">
            <template v-slot="{row}">
              <el-select v-model="row.freightProperty" :disabled="isdisabled">
                <el-option v-for="(item, key) in freightProperty" :key="key" :label="item" :value="item" />
              </el-select>
            </template>
          </el-table-column> -->
          <el-table-column prop="propertyNum" label="属性号" align="left" fixed="right" width="150">
            <template v-slot="{row}">
              <el-input v-model="row.propertyNum" :disabled="isdisabled ||row.isDisabled" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <p style="margin: 10px 0;">
        <span>实际结算金额合计:{{ applyGoodsBaseInfo.amountSumAll }}</span>
        <span>发货数量合计:{{ applyGoodsBaseInfo.invoiceSumAll }}</span>
      </p>
      <p style="font-size:16px;font-weight:800;margin: 10px 0;">
        原信息
      </p>
      <p>
        <span>收货地址：</span>
        <span>{{ applyGoodsBaseInfo.primaryReceiptAddress }}</span>
      </p>
      <p>
        <span>运输方式：</span>
        <span>{{ applyGoodsBaseInfo.primaryModelOfShipping }}</span>
        <span style="margin-left:20px">承运商：</span>
        <span>{{ applyGoodsBaseInfo.primaryCarrier }}</span>
      </p>
      <p style="font-size:16px;font-weight:800;margin: 10px 0;">
        变更后信息
      </p>
      <p v-if="applyGoodsBaseInfo.receiptAddress">
        <span>变更后收货地址：</span>
        <span>{{ applyGoodsBaseInfo.receiptAddress.receiverName }}</span>
        <span>{{ applyGoodsBaseInfo.receiptAddress.province }}</span>
        <span>{{ applyGoodsBaseInfo.receiptAddress.city }}</span>
        <span>{{ applyGoodsBaseInfo.receiptAddress.county }}</span>
        <span>{{ applyGoodsBaseInfo.receiptAddress.receiptAddress }}</span>
        <span>{{ applyGoodsBaseInfo.receiptAddress.receiverPhone }}</span>
      </p>
      <p>
        <span>变更后运输方式：</span>
        <span class="rj-baseinfo__item">
          {{ applyGoodsBaseInfo.modeOfShipping }}
        </span>
        <span>变更后承运商：</span>
        <span>
          {{ applyGoodsBaseInfo.carrier }}
        </span>
      </p>
      <p v-if="!isDirectOrder">
        <span>运费差价：{{ applyGoodsBaseInfo.freight }}元</span>
        <span class="rj-baseinfo__label">运费支付方式：</span>

        <span class="rj-baseinfo__item">
          <!-- <el-radio-group v-model="form.isRebate" @change="changisRebate">
            <el-radio :label="false">现金</el-radio>
            <el-radio :label="true">返利</el-radio>
          </el-radio-group> -->
          {{ applyGoodsBaseInfo.freightPayTypeStr }}
        </span>
      </p>
      <p v-if="!isDirectOrder">
        <span>价外费用合同号： <span style="color:#409EFF;cursor:pointer;" @click="backRouter">{{ applyGoodsBaseInfo.freightContractNum }}</span></span>
        <span>价外费用合同分配金额/比例：{{ applyGoodsBaseInfo.freightProportion }}</span>
      </p>
      <p>是否需要唛头：{{ applyGoodsBaseInfo.markType ? '是' : '否' }}</p>
      <p>
        <span>唛头单号: {{ applyGoodsBaseInfo.marksNum }}</span>
        <!-- <el-input v-model.trim="applyGoodsBaseInfo.marksNum" style="width:150px" placeholder="请输入唛头单号" :disabled="isdisabled" /> -->
      </p>
      <p>
        <span>收货回执及到货验收要求：</span>
        <el-input v-model.trim=" applyGoodsBaseInfo.receiptArrivalAcceptanceRequirements" type="textarea" :rows="3" :disabled="isdisabled" placeholder="请输入收货回执及到货验收要求" maxlength="200" show-word-limit />
      </p>
      <p>
        <span>发货备注说明：</span>
        <el-input v-model.trim="applyGoodsBaseInfo.deliverRemark" type="textarea" :rows="3" :disabled="isdisabled" placeholder="请输入发货备注说明" maxlength="200" show-word-limit />
      </p>
      <p>
        <span>回执附件：</span><br>
        <span v-for="(item,index) in fileList" :key="index">
          <el-link :underline="false" style="color:#409EFF" @click="fileClick(item)">{{ item.fileName }}</el-link>
        </span><br>
      </p>
      <p>
        <span>备注：</span>
        <el-input v-model.trim="applyGoodsBaseInfo.remark" type="textarea" :rows="3" :disabled="isdisabled" placeholder="请输入备注" maxlength="200" show-word-limit />
      </p>
      <p>
        <span>审批意见：</span>
        <el-input v-model.trim="applyGoodsBaseInfo.approvalOpinion" type="textarea" :rows="3" :disabled="isdisabled" placeholder="请输入审批意见" maxlength="200" show-word-limit />
      </p>
      <span v-if="!isdisabled" slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="agreeAllLoading" @click="agreeAll"> 批量同意</el-button>

        <el-button type="primary" :loading="agreeAllLoading" @click="rejectAll">批量驳回</el-button>
      </span>
    </div>
    <el-dialog
      title="驳回原因"
      :visible.sync="dialogVisible"
      width="360px"
      @close="revokeDialogClose"
    >
      <el-input
        v-model="deleteReason"
        type="textarea"
        placeholder="请输入撤销原因"
        maxlength="200"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="handleDeleteDebit">确定</el-button>
      </span>
    </el-dialog>
    <partShipCheck :id="partId" :dialog-form-visible="dialogFormVisible" @on-status-dialog="updataDialogFormVisible" />
    <logisticsNumber :dialog-form-visible-logist="dialogFormVisibleLogist" :form="formNum" @on-status-dialog="updataDialogFormVisibleLogist" />
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>

<script>

import lookserialNumber from '../../Chief/contract/common/lookserialNumber';
import logisticsNumber from '../../partShipCheck/logisticsNumber';
import partShipCheck from '../../partShipCheck';
import { orderGetPartialInvoiceDetail, attachmentGetToken, orderApprovalPartialInvoice, findPartialInvoiceInfoListByMasterContractId, rejectedPartialInvoice, batchRejected, batchThrough } from '@/API';
import { MathAdd } from '@/libs/util';
import Collapse from '@/components/Collapse';
// import { mapState } from 'vuex';
export default {
  inject: ['reload'],
  data () {
    return {
      isdisabled: false,
      transact: false,
      tableData: [],
      otherTableData: [],
      loading: false,
      listNumber: '',
      changeBussiness: '',
      changeBussinessOptions: ['默认物流', '顺丰'],
      goodsReceipt: '',
      goodsRemark: '',
      remark: '',
      isair: false,
      dialogFormVisible: false,
      dialogFormVisibleLogist: false,
      // loading
      agreeLoading: false,
      agreeAllLoading: false,
      formNum: {},
      partId: '',
      // 驳回参数
      dialogVisible: false,
      deleteReason: '',
      revokedata: {},
      applyGoodsBaseInfo: {
        primaryReceiptAddress: '',
        primaryModelOfShipping: '',
        primaryCarrier: '',
        receiptAddress: '',
        modeOfShipping: '',
        carrier: '',
        freight: '',
        freightPayTypeStr: '',
        freightContractNum: '',
        freightProportion: '',
        marksNum: '',
        authorizationEmail: '',
        receiptArrivalAcceptanceRequirements: '',
        deliverRemark: '',
        remark: '',
        approvalOpinion: ''

      },
      fileList: [],
      token: '',
      uploadUrl: '',
      downFileUrl: '',
      fileserveDownUrl: ''
    };
  },
  computed: {
    // ...mapState({
    //   freightProperty: state => state.enumeration.freightProperty
    // })
  },
  components: {
    lookserialNumber,
    logisticsNumber,
    partShipCheck,
    Collapse
  },
  methods: {
    initData () {
      this.loading = true;
      orderGetPartialInvoiceDetail({ id: this.$route.query.id }).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          // this.tableData = json.data.partialInvoiceVO;
          this.applyGoodsBaseInfo = json.data;
          // 给表格中添加textarea 字段 applyGoodsBaseInfo.partialInvoiceVO
          this.applyGoodsBaseInfo.partialInvoiceVO.forEach((item) => {
            this.$set(item, 'textarea', '');
          });
          this.applyGoodsBaseInfo.partialInvoiceVO.map((item) => {
            item.invoiceProductList.map((itemList) => {
              if (itemList.propertyNum !== '' && itemList.propertyNum !== null) {
                this.$set(itemList, 'isDisabled', true);
              } else {
                this.$set(itemList, 'isDisabled', false);
              }
              // return items;
            });
            // return item;
          });
          // 回显 文件
          this.fileList = this.applyGoodsBaseInfo.reversedInvoiceVO;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 文件服务器地址
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    // 下载文件地址
    fileClick (row) {
      this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    initDatatransact () {
      this.loading = true;
      findPartialInvoiceInfoListByMasterContractId({ 'id': this.$route.query.id }).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.otherTableData = json.data.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    backRouter () {
      this.$store.commit('pagesTemporary/SETOrderPersionContractListTabActive', '1');
      this.$router.replace({ name: 'orderPersionContractList' });
    },
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.settlementAmount(param.data);
        }
      });
      return sums;
    },
    // 实际结算金额总计
    productNum (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      // cont = Number(cont).toFixed(2);
      return cont;
    },
    settlementAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    getStatus () {
      // let status = this.$route.query.disable
      if (this.$route.query.isdisabled) {
        this.isdisabled = true;
      }
    },
    agree (tag) {
      // 删除其中属性
      this.agreeLoading = true;
      tag.invoiceProductList.forEach((item) => {
        this.$delete(item, 'isDisabled');
      });
      let parmas = {
        partialInvoiceProducts: tag.invoiceProductList,
        id: tag.id, // 主键
        marksNum: this.applyGoodsBaseInfo.marksNum, // 唛头单号
        authorizationEmail: '', // 云桌面授权邮箱
        deliverRemark: this.applyGoodsBaseInfo.deliverRemark, // 发货备注
        receiptArrivalAcceptanceRequirements: this.applyGoodsBaseInfo.receiptArrivalAcceptanceRequirements, // 收货回执及到货验收要求
        remark: this.applyGoodsBaseInfo.remark, // 备注
        approvalOpinion: this.applyGoodsBaseInfo.approvalOpinion// 审批意见

      };
      orderApprovalPartialInvoice(parmas).then((res) => {
        let json = res.data;
        this.loading = true;
        this.agreeLoading = false;
        if (json.status === '200') {
          // 成功标志
          this.loading = false;
          this.$message.success('审批成功');
          this.initData();
        } else {
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
        this.agreeLoading = false;
      });
    },
    revokeDialogClose () {
      this.deleteReason = '';
    },
    // 驳回原因接口
    reject (row) {
      this.revokedata = row;
      this.dialogVisible = true;
    },
    handleDeleteDebit () {
      let row = this.revokedata;
      if (this.deleteReason === '') {
        this.$message.error('请输入驳回原因');
        return;
      }
      // 调用接口
      let parmas = {
        id: row.id,
        approvalOpinion: this.deleteReason
      };
      rejectedPartialInvoice(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          // 成功标志
          this.loading = false;
          this.$message.success('驳回成功');
          this.initData();
          this.dialogVisible = false;
        } else {
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 批量同意
    agreeAll () {
      this.agreeAllLoading = true;
      // 操作数组
      let oldArr = this.applyGoodsBaseInfo.partialInvoiceVO;
      let newArr = [];
      // let updateArr = [];
      oldArr.map((item) => {
        newArr.push({
          id: item.id,
          productListList: item.invoiceProductList
        });
      });

      newArr.forEach((item) => {
        item.productListList.map((items) => {
          items = {
            id: items.id,
            propertyNum: items.propertyNum
          };
        });
      });
      let parmas = {
        marksNum: this.applyGoodsBaseInfo.marksNum, // 唛头单号
        authorizationEmail: '', // 云桌面授权邮箱
        deliverRemark: this.applyGoodsBaseInfo.deliverRemark, // 发货备注
        receiptArrivalAcceptanceRequirements: this.applyGoodsBaseInfo.receiptArrivalAcceptanceRequirements, // 收货回执及到货验收要求
        remark: this.applyGoodsBaseInfo.remark, // 备注
        approvalOpinion: this.applyGoodsBaseInfo.approvalOpinion, // 审批意见
        batchThroughProductList: newArr
      };
      batchThrough(parmas).then((res) => {
        this.agreeAllLoading = false;
        let json = res.data;
        if (json.status === '200') {
          // 成功标志
          this.loadingagreeAllLoading = false;
          this.$message.success('批量同意成功');
          this.$router.go(-1);
        } else {
          this.agreeAllLoading = false;
        }
      }).catch(() => {
        // this.agreeAllLoading = false;
        this.agreeAllLoading = false;
      });
    },
    // 批量驳回
    rejectAll () {
      if (this.applyGoodsBaseInfo.approvalOpinion === '') {
        this.$message.error('请输入审批意见');
        return;
      }
      this.agreeAllLoading = true;
      let parmas = {
        id: this.applyGoodsBaseInfo.partialId,
        approvalOpinion: this.applyGoodsBaseInfo.approvalOpinion
      };
      batchRejected(parmas).then((res) => {
        this.agreeAllLoading = false;
        let json = res.data;
        if (json.status === '200') {
          // 成功标志
          this.agreeAllLoading = false;
          this.$message.success('批量驳回成功');
          this.$router.go(-1);
        } else {
          this.agreeAllLoading = false;
        }
      }).catch(() => {
        this.agreeAllLoading = false;
      });
    },
    // 分批申请单号
    fpfh (row) {
      this.partId = row.id;
      this.dialogFormVisible = true;
    },
    // 组件事件
    updataDialogFormVisible (val) {
      this.dialogFormVisible = val;
    },
    // 物流单号接口
    logisticClick (row) {
      this.formNum = {
        invoiceNum: row.invoiceNum,
        logisticsNum: row.logisticsNum
      };
      this.dialogFormVisibleLogist = true;
    },
    // 组件事件
    updataDialogFormVisibleLogist (val) {
      this.dialogFormVisibleLogist = val;
    },
    istransact () {
      let transact = this.$route.query.transact;
      if (transact) {
        this.transact = true;
        this.initDatatransact();
      } else {
        this.transact = false;
        this.initData();
      }
    }
  },
  props: {
    contractId: {
      type: [String, Number],
      required: true
    },
    // 是否是直签合同
    isDirectOrder: {
      type: Boolean,
      required: false
    }
  },
  mounted () {
    this.getStatus();
    this.istransact();
    this.initToken();
  }
};
</script>

<style lang="scss" scoped>
.approve-style{
  >p{
    margin: 10px 0 ;
    >span{
      display: inline-block;
      margin-right: 10px;
    }
  }
}
</style>
